module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/mastercard-payment-card-d2fd784127d20afae10d60e3bdbb1e88.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/mastercard-payment-card.svg
// module id = BSrE
// module chunks = 24